const defaultState = {
  customers: null,
  error: null,
  fetching: false,
  fetched: false
};

const getCustomersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CUSTOMERS_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'CUSTOMERS_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, customers: action.payload.data
      };
    }
    case 'CUSTOMERS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        customers: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getCustomersReducer;


// WEBPACK FOOTER //
// ./src/reducers/getCustomers.js